import React from "react";
import "./Landing.css";

export default function Landing() {
  return (
    <>
      <div id="home" className="bg-color-land">
        <div className="title">
          DINOCARE
          <p>
            Know where you inherited your personality from the first species to
            roam on this planet with diverse characteristics.
          </p>
        </div>

        <div className="dino-bg">
          {" "}
          <img
            src="https://res.cloudinary.com/dzbdnlr0f/image/upload/v1631305497/DINOCARE/dinosaur-icon-2_j1k6bw.png"
            className="dino-bg-size"
            srcset=""
            alt="landingdino"
          />{" "}
        </div>
      </div>
    </>
  );
}
